import React from 'react'
import Popup from 'reactjs-popup'

const styles = {
  popupContentContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    alignItems: 'center',
    width: '100%'
  },
  popupParagraph: {
    textAlign: 'left',
    width: '100%',
    fontSize: '20px',
    color: '#6d357b'
  },
  contentStyle: {
    borderRadius: 12,
    boxShadow: '3px 3px 5px #00000080',
    padding: 8,
    maxWidth: '140px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    overlfow: 'scroll' // <-- This tells the modal to scroll
  }
}

class MenuSkeleton extends React.Component {
  renderPopupContent = (close) => {
    return (
      <div style={styles.popupContentContainer}>
        <div style={styles.popupParagraph} onClick={() => close()}>
          {this.props.textParagraph}
        </div>
      </div>
    )
  }

  renderPopup = () => {
    return (
      <Popup
        trigger={this.props.trigger}
        contentStyle={styles.contentStyle}
        position='bottom center'
        onOpen={this.props.onOpen}
        closeOnDocumentClick
      >
        {close =>
          <div className='modal'>
            {this.renderPopupContent(close)}
          </div>
        }
      </Popup>
    )
  }

  render () {
    return (
      <React.Fragment>
        {this.props.children}
        {this.renderPopup()}
      </React.Fragment>
    )
  }
}
export default MenuSkeleton



// WEBPACK FOOTER //
// ./src/services/Menu.js